import axiosInstance from './axiosInstance';
import config from '../config';
import { Customer, CreateCustomerDto, UpdateCustomerDto } from '../types/customers.types';

const API_URL = `${config.API_BASE_URL}/Customers`;

export const customersService = {
  getAll: async (): Promise<Customer[]> => {
    const response = await axiosInstance.get<Customer[]>(API_URL);
    return response.data;
  },

  getById: async (id: number): Promise<Customer> => {
    const response = await axiosInstance.get<Customer>(`${API_URL}/${id}`);
    return response.data;
  },

  create: async (customer: CreateCustomerDto): Promise<Customer> => {
    const response = await axiosInstance.post<Customer>(API_URL, customer);
    return response.data;
  },

  update: async (id: number, customer: UpdateCustomerDto): Promise<Customer> => {
    const response = await axiosInstance.put<Customer>(`${API_URL}/${id}`, customer);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await axiosInstance.delete(`${API_URL}/${id}`);
  },

  generateCode: async (): Promise<string> => {
    const response = await axiosInstance.get<string>(`${API_URL}/generate-code`);
    return response.data;
  },
};